<template>
  <v-progress-linear :indeterminate="true" />
</template>

<script>
import { Debouncer, getAllParentNodes } from '../../../libraries/common'
export default {
  props: ['disabled'],
  data() {
    return {
      scrollParents: [],
      debouncer: new Debouncer(20),
    };
  },
  methods: {
    checkPosition() {
      this.debouncer.clear()
        .push(() => {
          if (!this.disabled && this.isInViewport()) {
            this.$emit('input');
          }
        });
    },
    isInViewport() {
      const rect = this.$el.getBoundingClientRect();
      return rect.bottom <= (window.innerHeight || document.documentElement.clientHeight);
    }
  },
  watch: {
    disabled() {
      if (!this.disabled) {
        this.checkPosition();
      }
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisInfiniteLoader'] = this;

    this.scrollParents = getAllParentNodes(this.$el)
      .filter(f => ['scroll', 'auto'].includes(window.getComputedStyle(f).overflowY))
      .concat(window);

    this.scrollParents
      .forEach(parent => parent.addEventListener('scroll', this.checkPosition));

    this.$nextTick(this.checkPosition);
  },
  beforeDestroy() {
    this.scrollParents
      .forEach(parent => parent.removeEventListener('scroll', this.checkPosition));
  },
}
</script>